<template>
    <nav ref="sideMenu" class="gz-menu gz-sideMenu" :class="{'gz-sideMenu_hidden': !show, 'gz-sideMenu_shaddow': mobile && show}">
        <div class="gz-sideMenu__hide-control">
            <div class="gz-sideMenu__hide-control__icon">
                <span @click.stop="show = !show, menuItemShowStatus()" class="icon-menu_open-24px"></span>
            </div>
        </div>
        <!-- Menu Items slot -->
        <slot></slot>
    </nav>
</template>

<script>
export default {
    name: 'BaseSideMenu',

    data() {
        return {
            show: true
        }
    },
    methods: {
        menuItemShowStatus() {
            this.$store.dispatch('authLayoutSideMenuShow', this.show)
        }
    },
    computed: {
        mobile() {
            if (this.$store.getters['responsiveScreenWidth'] <= 1024) {
                return true
            }
        }
    },
    mounted() {
        this.show = false
        // if (this.$store.getters['responsiveScreenWidth'] <= 1024) {
        // }
    }
}
</script>